import React, { Component } from 'react';
import { getCurrentResource } from '../../util/tools';
import PlainFullDescription from '../../components/fulldescription/PlainFullDescription';
import styles from '../../components/fulldescription/FullDescription.module.css';
import { FORM_CONTACT_FT } from '../../util/consts/forms';
import { CLASS_CONTACT } from '../../util/consts/classes';

class ContactPage extends Component {

	constructor(props) {
		super(props);
		this.resource = getCurrentResource().pages.plain.Contact;
		this.plainInfo = {
			app: props.app,
			page: this,
			class: CLASS_CONTACT,
			instanceModelId: FORM_CONTACT_FT,
			instanceId: this.props.match.params.id,
			param: {}
		};
	}

	render() {
		return (
			<React.Fragment>
				<div className={styles.divPlainTitle}>
					{this.resource.title}
				</div>
				<PlainFullDescription plain={this.plainInfo} />
			</React.Fragment>
		)
	}
}

export default ContactPage;
